import { useRef, useEffect } from "react";
import { Toggle, LeftChevron, RightChevron, MarkFinishIcon, ArrowDown } from "../Icons/icons";
import crown from '../assets/crown.jpg';
const StudentHeader = ({ testGoverning, selectedTestId, markFinish, currentSlideData, courseInfo, setSidebarToggle, slidesArray, questionsArray, currentQuestionId, setCurrentSlideId, currentSlideId, setCurrentSlideData, setQuestion, setCurrentQuestionId, setStartTime }) => {

    const headerRef = useRef(null);

    useEffect(() => {
        if (testGoverning.isTestStarted) {
            const headerElement = headerRef.current;
            headerElement.style.display = "none";
        } else {
            const headerElement = headerRef.current;
            if (headerElement) {
                headerElement.style.display = "flex";
            }
        }

        if (testGoverning.isTestSubmitted) {
            const headerElement = headerRef.current;

            if (headerElement) {
                headerElement.style.display = "flex";
            }
        }

    }, [testGoverning])

    function nextSlide() {
        //[{id}{id}{id}]
        const currentSlideIndex = slidesArray.findIndex((slide) => slide.id === currentSlideId);
        setCurrentSlideId(slidesArray[currentSlideIndex + 1].id);
        setCurrentSlideData(slidesArray[currentSlideIndex + 1]);
        const now = new Date();


        setStartTime(new Date().toISOString().slice(0, 19).replace('T', ' '))
    }

    function previousSlide() {
        const currentSlideIndex = slidesArray.findIndex(slide => slide.id === currentSlideId);
        setCurrentSlideId(slidesArray[currentSlideIndex - 1].id);
        setCurrentSlideData(slidesArray[currentSlideIndex - 1]);
        setStartTime(new Date().toISOString().slice(0, 19).replace('T', ' '))
    }

    const disableStyle = {
        pointerEvents: "none",
        color: "grey"
    }

    function disableNext() {
        if (currentSlideId === slidesArray[slidesArray.length - 1].id) return disableStyle;
        return {}
    }

    function disablePrevious() {
        if (currentSlideId === slidesArray[0].id) return disableStyle;
        return {}
    }

    //function for questions next and previous

    function nextQuestion() {
        //[{id}{id}{id}]
        const currentQuestionIndex = questionsArray.findIndex((questionsArray) => questionsArray.id === currentQuestionId);
        setCurrentQuestionId(questionsArray[currentQuestionIndex + 1].id);
        setQuestion(questionsArray[currentQuestionIndex + 1]);
    }

    function previousQuestion() {
        const currentQuestionIndex = questionsArray.findIndex(questionsArray => questionsArray.id === currentQuestionId);
        setCurrentQuestionId(questionsArray[currentQuestionIndex - 1].id);
        setQuestion(questionsArray[currentQuestionIndex - 1]);

    }

    function disableNextQuestion() {
        if (currentQuestionId === questionsArray[questionsArray.length - 1].id) return disableStyle;
        return {}
    }

    function disablePreviousQuestion() {
        if (currentQuestionId === questionsArray[0].id) return disableStyle;
        return {}
    }

    return (
        <>
            {
                courseInfo && (
                    <div ref={headerRef} className="z-10 flex justify-between px-6 py-2 bg-white"
                    style={{ boxShadow: "0px 2px 2px 0px rgba(20, 29, 34, 0.10)" }}
                    
                    >
                        <div className="flex items-center">
                            <div className="cursor-pointer" onClick={() => {
                                setSidebarToggle((sidebarToggle) => {
                                    return !sidebarToggle;
                                })
                            }}>
                                <Toggle />
                            </div>
                            <div className="flex flex-col items-start py-0 px-4">
                                <span className="text-2xl font-bold">{courseInfo.course_name}</span>
                                {/* <span className="text-gray-500 text-xs truncate max-w-96 2xl:text-lg" title={courseInfo.course_desc}>{courseInfo.course_desc}</span> */}
                            </div>
                        </div>
                        <rect xmlns="http://www.w3.org/2000/svg" x="0.299988" width="24" height="24" fill="url(#pattern0_604_14575)" />
                        <div className="flex items-center  gap-4">
                            <div className="flex gap-2 px-4 h-[40px] py-2 border border-borderColor">
                                <img src={crown} alt="crown image" />
                                <div>3654</div>
                                <div><ArrowDown /> </div>
                            </div>
                            {
                                !selectedTestId && (
                                    <button className={`border flex items-center justify-center p-1 w-[40px] h-[40px] ${currentSlideData?.finished ? "bg-[#F2994A26] border border-[#F2994A]" : ""}`} disabled={currentSlideData?.finished} onClick={() => { markFinish(currentSlideId) }}>
                                        <MarkFinishIcon color={currentSlideData?.finished ? '#F2994A' : ''} />
                                    </button>
                                )
                            }

                            {/* <i class="fa-solid fa-palette icon-medium bordered-icon"></i> */}
                            {
                                slidesArray && (
                                    <div className='flex items-center gap-2'>
                                        {/*  */}
                                        <div style={disablePrevious()} onClick={previousSlide} className="flex items-center justify-center cursor-pointer border border-[#E0E0E0] w-[40px] h-[40px]">
                                            <LeftChevron />
                                        </div>
                                        <div style={disableNext()} onClick={nextSlide} className="flex items-center justify-center cursor-pointer border border-[#E0E0E0] w-[40px] h-[40px]">
                                            <RightChevron />
                                        </div>
                                    </div>
                                )
                            }
                            {
                                questionsArray && (
                                    <div className="flex items-center gap-2">
                                        <div style={disablePreviousQuestion()} onClick={previousQuestion} className="flex items-center justify-center cursor-pointer border border-[#E0E0E0] w-[40px] h-[40px]">
                                            <LeftChevron />
                                        </div>
                                        {/* <svg style={disablePreviousQuestion()} onClick={previousQuestion} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 cursor-pointer">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                                    </svg> */}
                                        <div style={disableNextQuestion()} onClick={nextQuestion} className="flex items-center justify-center cursor-pointer border border-[#E0E0E0] w-[40px] h-[40px]">
                                            <RightChevron />
                                        </div>
                                        {/* <svg style={disableNextQuestion()} onClick={nextQuestion} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 cursor-pointer">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                                    </svg> */}
                                    </div>
                                )
                            }
                        </div>
                    </div>
                )
            }
        </>
    );
}

export default StudentHeader;